<div ng-init="imggif2='/assets/img/Foster-Animation-v05-01.gif'">
	<img [src]="imggif" alt="">
</div>